import { useEffect, useState } from 'react';
import { navItems, siteName } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleJump = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[68px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <button
          type="button"
          onClick={() => handleJump('top')}
          className="flex items-center gap-2 cursor-pointer"
          aria-label={`${siteName} 返回顶部`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            {siteName}
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => handleJump(item.id)}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => handleJump('getting-started')}
            className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-guide-line"></i>
            使用指南
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 anim-fade">
          <nav className="mx-auto grid max-w-[1200px] grid-cols-2 gap-1 px-4 py-3 md:px-6">
            {navItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => handleJump(item.id)}
                className="rounded-md px-3 py-2.5 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer"
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}